import { helpers } from '@vuelidate/validators'
import type { IRadioValidator } from './useRadio.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useRadio(
  field: string,
  t: TInstance,
  options: IRadioValidator,

) {
  const isCheckedValidator = (value: unknown) => typeof value === 'boolean'

  return ({
    [`${field}`]: {
      // Use this validator if you want to check is any value checked (like a radio buttons)
      ...(options.isChecked && {
        isChecked: helpers.withMessage(
          () => t('formValidatorMessages.radio.required'),
          isCheckedValidator,
        ),
      }),
    },
  })
}
